import { Component, OnInit } from '@angular/core';
import { StepTemplateBaseComponent } from '../step-template-base/step-template-base.component';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { NotificationService } from 'app/core/services/notification.service';
import { ChildState } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.component';
import { DynamicOnboardingService } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.service';

@Component({
  selector: 'itpx-employees-card',
  templateUrl: './employees-card.component.html',
  styleUrls: ['./employees-card.component.css']
})
export class EmployeesCardComponent extends StepTemplateBaseComponent {
  private form: FormGroup;
  private invitedEmployees: any[] = [];
  private employeeRoles$: Observable<any>;

  constructor(
    private fb: FormBuilder,
    private configService: ConfigService,
    private service: DynamicOnboardingService,
    private notificationService: NotificationService
  ) {
    super();
  }

  ngOnInit() {
    this.employeeRoles$ = this.service.getRoles().share();
    // this.employeeRoles$.subscribe(val => this.dictionary = val);
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.pattern(this.configService.get('validators').email), this.emailValidator()],
        // this.validateEmailNotTaken.bind(this)
      ],
      roles: [[], [Validators.required]],
      firstName: [null, [Validators.required, this.service.whitespaceValidation()]],
      lastName: [null, [Validators.required, this.service.whitespaceValidation()]]
    });

    let dispatch$ = this.next.bindToLifecycle(this).filter(value => this.id === value).switchMap(_ => {
      if (this.form.valid) {
        this.onSubmit();
      }
      return Observable.from(this.parentForm.controls.employees.value)
        .concatMap(employee => this.service.addEmployee(employee))
        .catchAndEmit('error')
        .reduce((acc, curr) => acc.concat(curr), []);
    }).share();
    
    dispatch$.bindToLifecycle(this)
    .subscribe(emitted => {
      this.status.emit(!emitted.some(resp => resp === 'error') ? ChildState.done : ChildState.error);
      const firstFail = emitted.indexOf('error');
      this.invitedEmployees.splice(0, -1 < firstFail ? firstFail : this.invitedEmployees.length);
      let formEmployees = this.parentForm.get('employees').value;
      formEmployees.splice(0, -1 < firstFail ? firstFail : formEmployees.length);
      this.parentForm.get('employees').setValue(formEmployees);
      this.pushMessage();
    });

    dispatch$.filter(emitted => emitted && emitted.length > 0)
      .switchMap(_ => this.service.getEmployees()).bindToLifecycle(this)
      .subscribe(registerdEmployees => this.parentForm.get('registeredEmployees').setValue(registerdEmployees));

    this.status.emit(ChildState.enabled); //Enable next button
  }

  onSubmit() {
    let employee = this.form.getRawValue();
    const rolesTmp = employee.roles.map(id => ({ id: id }));
    employee.roles = rolesTmp;
    this.parentForm.controls.employees.value.push(employee);
    this.invitedEmployees.push(this.form.controls.email.value);
    this.form.reset();
    this.pushMessage();
  }

  onEmployeeRemoveClick(email: string) {
    const idx = <Array<any>>(this.parentForm.controls.employees.value).findIndex(employee => employee.email === email);
    this.parentForm.controls.employees.value.splice(idx, 1);
    const localIdx = this.invitedEmployees.findIndex(employee => employee === email);
    this.invitedEmployees.splice(localIdx, 1);
    this.pushMessage();
    // throw new Error('onEmployeeRemoveClick() pending implementation');
  }

  pushMessage() {
    if (0 < this.invitedEmployees.length)
      this.message.emit({
        label: 'beforeNext',
        text: `By clicking <b>Next</b> the above ${this.invitedEmployees.length} employee${this.invitedEmployees.length > 1 ? 's' : ''} will be invited`
      });
    else
      this.message.emit({ label: 'beforeNext', text: '' });
  }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      return (this.parentForm.get('registeredEmployees').value.find(it => it.email === control.value)
        || this.parentForm.get('employees').value.find(it => it.email === control.value)) ?
        { custom: { message: 'Email is already taken' } } : null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/dynamic-onboarding/employees-card/employees-card.component.ts